import React, {useState} from 'react';
import ContactForm from '../ContactForm';
import './style.scss';
import FooterLogo from '../../assets/images/logo_images/logo.svg';
import MapIcon from '../../assets/images/mapIcon.svg';
import Phone from '../../assets/icons/phone.png';
import Email from '../../assets/icons/email.png';
import Linkedin from '../../assets/icons/linkedin.png';
// import Instagram from '../../assets/icons/instagram.png';
import Fb from '../../assets/icons/fb.png';
import Modal from './modal';
import {useTranslation} from "react-i18next";

const Footer = () => {
    const {t} = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({title: '', body: null});

    const openModal = (type) => {
        if (type === 'privacy') {
            setModalContent({
                title: 'Privacy Policy',
                body: (<div className="text-container">
                    <h3>{t('privacyPolicy.effectiveDate')}</h3>
                    <p>{t('privacyPolicy.intro')}</p>
                    <p>{t('privacyPolicy.acknowledgement')}</p>

                    <h4>{t('privacyPolicy.sections.dataController.title')}</h4>
                    <ul>
                        <li><strong>{t('privacyPolicy.sections.dataController.businessName')}</strong></li>
                        <li><strong>{t('privacyPolicy.sections.dataController.website')}</strong></li>
                        <li><strong>{t('privacyPolicy.sections.dataController.email')}</strong></li>
                        <li><strong>{t('privacyPolicy.sections.dataController.address')}</strong></li>
                    </ul>

                    <h4>{t('privacyPolicy.sections.dataCollection.title')}</h4>
                    <p>{t('privacyPolicy.sections.dataCollection.intro')}</p>
                    <ul>
                        <li>{t('privacyPolicy.sections.dataCollection.identity')}</li>
                        <li>{t('privacyPolicy.sections.dataCollection.contact')}</li>
                        <li>{t('privacyPolicy.sections.dataCollection.professional')}</li>
                        <li>{t('privacyPolicy.sections.dataCollection.technical')}</li>
                        <li>{t('privacyPolicy.sections.dataCollection.usage')}</li>
                        <li>{t('privacyPolicy.sections.dataCollection.preferences')}</li>
                    </ul>

                    <h4>{t('privacyPolicy.sections.dataCollectionMethods.title')}</h4>
                    <ul>
                        <li>{t('privacyPolicy.sections.dataCollectionMethods.direct')}</li>
                        <li>{t('privacyPolicy.sections.dataCollectionMethods.automated')}</li>
                        <li>{t('privacyPolicy.sections.dataCollectionMethods.thirdParties')}</li>
                    </ul>

                    <h4>{t('privacyPolicy.sections.dataUsage.title')}</h4>
                    <p>{t('privacyPolicy.sections.dataUsage.intro')}</p>
                    <ul>
                        <li>{t('privacyPolicy.sections.dataUsage.jobMatching')}</li>
                        <li>{t('privacyPolicy.sections.dataUsage.communication')}</li>
                        <li>{t('privacyPolicy.sections.dataUsage.compliance')}</li>
                        <li>{t('privacyPolicy.sections.dataUsage.websiteImprovement')}</li>
                        <li>{t('privacyPolicy.sections.dataUsage.marketing')}</li>
                    </ul>

                    <h4>{t('privacyPolicy.sections.dataSharing.title')}</h4>
                    <p>{t('privacyPolicy.sections.dataSharing.intro')}</p>
                    <ul>
                        <li>{t('privacyPolicy.sections.dataSharing.employers')}</li>
                        <li>{t('privacyPolicy.sections.dataSharing.serviceProviders')}</li>
                        <li>{t('privacyPolicy.sections.dataSharing.legalAuthorities')}</li>
                        <li>{t('privacyPolicy.sections.dataSharing.partners')}</li>
                    </ul>
                    <p>{t('privacyPolicy.sections.dataSharing.noSale')}</p>

                    <h4>{t('privacyPolicy.sections.dataRetention.title')}</h4>
                    <p>{t('privacyPolicy.sections.dataRetention.content')}</p>

                    <h4>{t('privacyPolicy.sections.dataSecurity.title')}</h4>
                    <p>{t('privacyPolicy.sections.dataSecurity.intro')}</p>
                    <ul>
                        <li>{t('privacyPolicy.sections.dataSecurity.encryptedCommunications')}</li>
                        <li>{t('privacyPolicy.sections.dataSecurity.secureServers')}</li>
                        <li>{t('privacyPolicy.sections.dataSecurity.securityAudits')}</li>
                    </ul>

                    <h4>{t('privacyPolicy.sections.gdprRights.title')}</h4>
                    <p>{t('privacyPolicy.sections.gdprRights.intro')}</p>
                    <ul>
                        <li>{t('privacyPolicy.sections.gdprRights.access')}</li>
                        <li>{t('privacyPolicy.sections.gdprRights.correction')}</li>
                        <li>{t('privacyPolicy.sections.gdprRights.erasure')}</li>
                        <li>{t('privacyPolicy.sections.gdprRights.restriction')}</li>
                        <li>{t('privacyPolicy.sections.gdprRights.portability')}</li>
                        <li>{t('privacyPolicy.sections.gdprRights.objection')}</li>
                        <li>{t('privacyPolicy.sections.gdprRights.withdrawConsent')}</li>
                    </ul>
                    <p>{t('privacyPolicy.sections.gdprRights.contact')}</p>

                    <h4>{t('privacyPolicy.sections.cookies.title')}</h4>
                    <p>{t('privacyPolicy.sections.cookies.content')}</p>

                    <h4>{t('privacyPolicy.sections.dataTransfers.title')}</h4>
                    <p>{t('privacyPolicy.sections.dataTransfers.content')}</p>

                    <h4>{t('privacyPolicy.sections.policyChanges.title')}</h4>
                    <p>{t('privacyPolicy.sections.policyChanges.content')}</p>

                    <h4>{t('privacyPolicy.sections.contactInformation.title')}</h4>
                    <p>{t('privacyPolicy.sections.contactInformation.intro')}</p>
                    <ul>
                        <li><strong>{t('privacyPolicy.sections.contactInformation.email')}</strong></li>
                        <li><strong>{t('privacyPolicy.sections.contactInformation.address')}</strong></li>
                    </ul>
                </div>)
            });
        } else if (type === 'terms') {
            setModalContent({
                title: 'Terms & Conditions',
                body: (
                    <div className="text-container">
                        <h3>{t('termsAndConditions.effectiveDate')}</h3>
                        <p>{t('termsAndConditions.intro')}</p>
                        <p>{t('termsAndConditions.acknowledgement')}</p>

                        <h4>{t('termsAndConditions.sections.acceptanceOfTerms.title')}</h4>
                        <p>{t('termsAndConditions.sections.acceptanceOfTerms.content')}</p>

                        <h4>{t('termsAndConditions.sections.ourServices.title')}</h4>
                        <p>{t('termsAndConditions.sections.ourServices.content')}</p>

                        <h4>{t('termsAndConditions.sections.userResponsibilities.title')}</h4>
                        <p>{t('termsAndConditions.sections.userResponsibilities.intro')}</p>
                        <ul>
                            <li>{t('termsAndConditions.sections.userResponsibilities.points.0')}</li>
                            <li>{t('termsAndConditions.sections.userResponsibilities.points.1')}</li>
                            <li>{t('termsAndConditions.sections.userResponsibilities.points.2')}</li>
                        </ul>
                        <p>{t('termsAndConditions.sections.userResponsibilities.content')}</p>

                        <h4>{t('termsAndConditions.sections.intellectualProperty.title')}</h4>
                        <p>{t('termsAndConditions.sections.intellectualProperty.content')}</p>
                        <p>{t('termsAndConditions.sections.intellectualProperty.restrictions')}</p>
                        <ul>
                            <li>{t('termsAndConditions.sections.intellectualProperty.points.0')}</li>
                            <li>{t('termsAndConditions.sections.intellectualProperty.points.1')}</li>
                        </ul>

                        <h4>{t('termsAndConditions.sections.thirdPartyLinks.title')}</h4>
                        <p>{t('termsAndConditions.sections.thirdPartyLinks.content')}</p>

                        <h4>{t('termsAndConditions.sections.privacyPolicy.title')}</h4>
                        <p>{t('termsAndConditions.sections.privacyPolicy.content')}</p>

                        <h4>{t('termsAndConditions.sections.limitationOfLiability.title')}</h4>
                        <p>{t('termsAndConditions.sections.limitationOfLiability.intro')}</p>
                        <ul>
                            <li>{t('termsAndConditions.sections.limitationOfLiability.points.0')}</li>
                            <li>{t('termsAndConditions.sections.limitationOfLiability.points.1')}</li>
                        </ul>

                        <h4>{t('termsAndConditions.sections.disclaimers.title')}</h4>
                        <p>{t('termsAndConditions.sections.disclaimers.content')}</p>
                        <p>{t('termsAndConditions.sections.disclaimers.additionalContent')}</p>

                        <h4>{t('termsAndConditions.sections.indemnification.title')}</h4>
                        <p>{t('termsAndConditions.sections.indemnification.content')}</p>

                        <h4>{t('termsAndConditions.sections.termination.title')}</h4>
                        <p>{t('termsAndConditions.sections.termination.content')}</p>

                        <h4>{t('termsAndConditions.sections.governingLaw.title')}</h4>
                        <p>{t('termsAndConditions.sections.governingLaw.content')}</p>

                        <h4>{t('termsAndConditions.sections.modifications.title')}</h4>
                        <p>{t('termsAndConditions.sections.modifications.content')}</p>

                        <h4>{t('termsAndConditions.sections.contactInformation.title')}</h4>
                        <p>{t('termsAndConditions.sections.contactInformation.intro')}</p>
                        <ul>
                            <li><strong>{t('termsAndConditions.sections.contactInformation.email')}</strong></li>
                            <li><strong>{t('termsAndConditions.sections.contactInformation.address')}</strong></li>
                        </ul>
                    </div>
                )
            });
        }
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <footer className="footer">
                <div className="container">
                    <div className="grid grid-cols-2 gap-100">
                        <div className="footer-left">
                            <div className="logo">
                                <img src={FooterLogo} alt={'footer-logo'}/>
                            </div>
                            <div className="title">
                                <img src={MapIcon} alt={'map-icon'}/>
                                <span>Head Office:</span>
                            </div>
                            <div className="address">
                                <p>222 & 224, 2nd Floor, Ansal Chambers-II 6, Bhikaji Cama Place, New Delhi - 110066</p>

                                <ul>
                                    <li>Co. Name - M/S RVDK LABOURHOME PVT. LTD.</li>
                                    <li>MEA License no - B-2223/DEL/COM/1000+/5/10684/2024</li>
                                    <li>DOI- 07.03.2024 DOE-22.02.2029</li>
                                </ul>
                            </div>
                            <hr className="footer-border"/>
                            <div className="footer-contact">
                                <div className="left">
                                    <ul className="contact-lisitng">
                                        <li><img src={Phone} alt={'phone'}/><span>+91 9218067167</span></li>
                                        <li><img src={Email} alt={'email'}/><span>jobs@labourhomeindia.com</span></li>
                                    </ul>
                                </div>
                                <div className="right">
                                    <ul className="social-linking">
                                        <li><a href='https://www.linkedin.com/company/linkedin.com-lhyug/'
                                               target='blank'><img src={Linkedin} alt={'linkedin'}/></a></li>
                                        {/* <li><img src={Instagram} alt={'instagram'} /></li> */}
                                        <li><a href='https://www.facebook.com/LHYUG/'
                                               target='blank'><img src={Fb} alt={'fb'}/></a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className='national-site'>
                                <p> Checkout are domestic site </p>
                                <a target='blank' href='https://labourhomeindia.com/'>labourhomeindia.com</a>
                            </div>
                        </div>
                        <div className="footer-right">
                            <ContactForm/>
                        </div>
                    </div>
                </div>
                <div className="copyright">
                    <div className="container">
                        <div className="copyright-wrapper">
                            <div className="left">
                                <p>Copyright © 2023 Labourhome. All rights reserved.</p>
                            </div>
                            <div className="right">
                                <ul>
                                    <li>
                                        <a onClick={() => openModal('privacy')}>Privacy Policy</a>
                                    </li>
                                    <li>
                                        <a onClick={() => openModal('terms')}>Terms & Conditions</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            {/* Modal component */}
            <Modal isOpen={isModalOpen} onClose={closeModal} content={modalContent}/>
        </>
    );
};

export default Footer;
